import { z } from 'zod';
import { BuyerTypeSchema } from './enums.schema.js';
// Phase 10a — read shape only. Mutation schemas (create/supersede/
// deprecate) for the operator admin surface land in 10b, mirroring
// the rate-card admin pattern from 8c.
export const CancellationPolicyResponseSchema = z.object({
    id: z.string().uuid(),
    buyerType: BuyerTypeSchema,
    hoursBeforeThreshold: z.number().int().positive(),
    chargePct: z.string(), // Decimal as string for JSON safety
    effectiveFrom: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
    effectiveTo: z
        .string()
        .regex(/^\d{4}-\d{2}-\d{2}$/)
        .nullable(),
    isCurrent: z.boolean(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
export const CancellationPolicyLadderSchema = z.object({
    buyerType: BuyerTypeSchema,
    asOf: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
    thresholds: z.array(z.object({
        hoursBefore: z.number().int().positive(),
        chargePct: z.number().min(0).max(100),
    })),
});
//# sourceMappingURL=cancellation-policy.schema.js.map